import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@faire/web--source/slate/Typography";
import { Medium } from "@faire/web--source/ui/Typography/Span";
import { observer } from "mobx-react";
import * as React from "react";
/* eslint-disable @faire/no-dollar-symbol-in-strings */ var AmexIncentiveBannerBase = function() {
    return /*#__PURE__*/ _jsxs(Typography, {
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(Medium, {
                children: "Get $100 off"
            }),
            " your first order of $150 or more!"
        ]
    });
};
export var AmexIncentiveBanner = observer(AmexIncentiveBannerBase);
